module.exports = __webpack_public_path__ + "img/chat-avatar.4fc06c1b.svg";